import * as Redux from "redux";
import { MainState } from "../../../../Core/reducers";
import { CoughSession, isModelWithError } from "../../../../misc/api/apiTypes";
import { WebPortalLegacyClientInternal } from "../../../../misc/api/WebPortalTokenClient";
declare var rootUrl: string;


export type ReprocessCoughSessionListActions = ShowModalAction | CloseModalAction | CompleteAction | ApplyAuditAnnotationAction | CheckForEventsStartAction | CheckForEventsDoneAction | CheckForEventsErrorAction;


export enum ReprocessCoughSessionModalActionTypes {
    ShowModal = '[ReprocessCoughSessionModal] ShowModal',
    CloseModal = '[ReprocessCoughSessionModal] CloseModal',
    AuditTrail = '[ReprocessCoughSessionModal] AuditTrail',
    Complete = '[ReprocessCoughSessionModal] Complete',
    ApplyAuditAnnotation = '[ReprocessCoughSessionModal] ApplyAuditAnnotation',
    CheckForEventsStart = '[ReprocessCoughSessionModal] CheckForEventsStart',
    CheckForEventsDone = '[ReprocessCoughSessionModal] CheckForEventsDone',
    CheckForEventsError = '[ReprocessCoughSessionModal] CheckForEventsError',
    ReprocessDone = '[ReprocessCoughSessionModal] ReprocessDone',
    ReprocessError = '[ReprocessCoughSessionModal] ReprocessError',
    ReprocessStart = '[ReprocessCoughSessionModal] ReprocessStart'
}

/**
 * Checking for events that would prevent the cough session from reprocessing.
 * */
export class CheckForEventsAsyncAction {
    static create(coughSessionId: string, legacyClient: WebPortalLegacyClientInternal) {
        return (dispatch: Redux.Dispatch<MainState>, getState: () => MainState) => {

            dispatch(CheckForEventsStartAction.create());

            legacyClient.getEventsForSession(coughSessionId)
                .then(json => {
                    dispatch(CheckForEventsDoneAction.create(json));
                })
                .catch(err => {
                    dispatch(CheckForEventsErrorAction.create(err.Message));
                });
        };
    }
}

//The reprocess cough session action that will send a request to the server
//to reprocess a cough session.
export class ShowModalAction implements Redux.Action {
    type: ReprocessCoughSessionModalActionTypes.ShowModal;
    coughSession: CoughSession

    static create(coughSession: CoughSession): ShowModalAction {
        return {
            type: ReprocessCoughSessionModalActionTypes.ShowModal,
            coughSession: coughSession
        };
    };
}

export class CloseModalAction implements Redux.Action {
    type: ReprocessCoughSessionModalActionTypes.CloseModal;

    static create(): CloseModalAction {
        return {
            type: ReprocessCoughSessionModalActionTypes.CloseModal
        }
    }
}

export class CompleteAction implements Redux.Action {
    type: ReprocessCoughSessionModalActionTypes.Complete;

    static create(): CompleteAction {
        return {
            type: ReprocessCoughSessionModalActionTypes.Complete
        }
    }
}

export class ApplyAuditAnnotationAction implements Redux.Action {
    type: ReprocessCoughSessionModalActionTypes.ApplyAuditAnnotation;
    auditAnnotation: string

    static create(auditAnnotation: string): ApplyAuditAnnotationAction {
        return {
            type: ReprocessCoughSessionModalActionTypes.ApplyAuditAnnotation,
            auditAnnotation: auditAnnotation
        }
    }
}

export class CheckForEventsStartAction implements Redux.Action {
    type: ReprocessCoughSessionModalActionTypes.CheckForEventsStart;

    static create(): CheckForEventsStartAction {
        return {
            type: ReprocessCoughSessionModalActionTypes.CheckForEventsStart
        }
    }
}

export class CheckForEventsDoneAction implements Redux.Action {
    type: ReprocessCoughSessionModalActionTypes.CheckForEventsDone;
    analysisSetsWithEvents: string[];

    static create(analysisSetsWithEvents: string[]): CheckForEventsDoneAction {
        return {
            type: ReprocessCoughSessionModalActionTypes.CheckForEventsDone,
            analysisSetsWithEvents: analysisSetsWithEvents
        };
    }
}

export class CheckForEventsErrorAction implements Redux.Action {
    type: ReprocessCoughSessionModalActionTypes.CheckForEventsError;
    error: string

    static create(error: string): CheckForEventsErrorAction {
        return {
            type: ReprocessCoughSessionModalActionTypes.CheckForEventsError,
            error: error
        };
    }
}
